// extracted by mini-css-extract-plugin
export var breadcrumb = "_10-0";
export var breadcrumbArrow = "_10-1";